<template>
  <div class="app-input">
    <component
      :is="icon"
      class="app-input__icon"
    />
    <input
      class="app-input__field"
      :class="{ 'app-input__field_with-icon': !!icon }"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      @input="changeInput"
    >
  </div>
</template>

<script>
import IconUser from '../Icons/IconUser';
import IconEmail from '../Icons/IconEmail';
import IconMap from '../Icons/IconMap';
import IconPhone from '../Icons/IconPhone';
import IconLocation from '../Icons/IconLocation';

export default {
  name: 'AppInput',
  components: {
    IconUser,
    IconEmail,
    IconMap,
    IconPhone,
    IconLocation,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: '',
    },
  },
  methods: {
    changeInput(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-input {
    position: relative;
    width: 300px;
    height: 45px;

    &__icon {
      margin-left: 16px;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &__field {
      height: 100%;
      border: 1px solid #606060;
      border-radius: 8px;
      width: 100%;
      padding: 0 10px;
      outline: none;
      transition: all .3s;
      font-size: 17px;
      &_with-icon {
        padding-left: 45px;
      }

      &:focus, &:hover {
        border: 1px solid dodgerblue;
      }
    }
  }

  ::placeholder {
    color: #000000;
    font-family: "Open Sans","sans-serif";
    font-size: 15px;
  }

@media (max-width: 576px) {
  ::placeholder {
    line-height: 20px;
  }
}
</style>
